<template>
    <ChildFormModel
        :add-action="addAction"
        :update-action="updateAction"
        :delete-action="deleteAction"
        :view-action="viewAction"
        category="ISSUE"
    />
</template>

<script>
import ChildFormModel from "@/views/Notification/ControlProgram/Components/ChildFormModel.vue";

export default {
    name: "ChildControlIssueForm",
    components: {ChildFormModel},
    props: {
        addAction: Boolean,
        updateAction: Boolean,
        deleteAction: Boolean,
        viewAction: Boolean,
    }
}
</script>

<style scoped>

</style>